<template>
  <div class="unlock-account">
    <HKLModal
      ref="modal"
      class="unlock-account__modal"
      :title="$t('settings.user.unlock.title')"
      :closable="true"
      :okBtnDisabled="disabledUnlockBtn"
      okBtnAction="unlock"
      size="medium"
      @onOkClick="unlock"
    >
      <div class="user-option">
        <label>{{ $t('user.usernameEmailAddress') }}</label>
        <HKLSelect
          class="unlock-list-dropdown"
          :value="selectDefaultValue"
          :options="options"
          :showSearch="true"
          @select="updateList"
        />
      </div>
      <div>
        <SimpleTable
          ref="usersToBeUnlock"
          class="simple-table"
          :removable="true"
          :headers="candidateTableHeaders"
          @removeRow="removeUser"
        />
      </div>
    </HKLModal>
  </div>
</template>

<script>
import lodash from 'lodash'
import { ref, unref, getCurrentInstance, computed } from 'vue-demi'
import HKLModal from '@/controls/Modal/HKLModal.vue'
import HKLSelect from '@/controls/Select/HKLSelect'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { getLockedUsers, unlockAccounts } from '@/api/accounts/request'
import SimpleTable from '@/controls/SimpleTable'
import i18n from '@/utils/i18n'
import { portalName } from '@/modules/portalName'

export default {
  components: {
    HKLModal,
    HKLSelect,
    SimpleTable,
  },
  setup () {
    const { proxy } = getCurrentInstance()

    const originList = ref([])
    const selectDefaultValue = []
    const options = ref([])
    const modals = useRefModal()
    const open = async () => {
      const users = await getLockedUsers()
      originList.value = lodash.cloneDeep(users)
      options.value = formatUsers(users)
      modals.open()
    }
    const candidateTableHeaders = [
      {text: i18n.t('settings.user.vendor.username'), label: 'username'},
      {text: i18n.t('settings.user.unlock.portal'), label: 'portal'},
    ]
    const disabledUnlockBtn = computed(() => {
      return unref(originList).length === unref(options).length
    })
    const updateList = (val) => {
      const user = JSON.parse(val)
      proxy.$refs.usersToBeUnlock.addContent(user)
      const index = options.value.findIndex(option => option.value.id === user.id)
      options.value.splice(index, 1)
    }
    const removeUser = (user) => {
      options.value.push(formatContent(user))
    }
    const formatUsers = (users) => {
      return users.map(item => {
        const formatUser = {
          id: item.id,
          userId: item.userId,
          username: item.user.username,
          domain: item.user.domain,
          portal: portalName()[item.user.domain],

        }
        return formatContent(formatUser)
      })
    }
    const formatContent = (user) => {
      return {
        name: `${user.username}  (${user.portal})`,
        value: { id: user.id, userId: user.userId, username: user.username, domain: user.domain, portal: user.portal },
      }
    }
    const unlock = async () => {
      const unlockList = proxy.$refs.usersToBeUnlock.getContents()
      await unlockAccounts(unlockList)
    }
    return {
      ...modals,
      list: originList,
      options: computed(() => unref(options).sort((a, b) => a.name.localeCompare(b.name))),
      open,
      updateList,
      candidateTableHeaders,
      removeUser,
      unlock,
      selectDefaultValue,
      disabledUnlockBtn,
    }
  },
}
</script>

<style lang="scss" scoped>

.unlock-account {
  &__modal ::v-deep {
    .ant-select-dropdown-menu-item {
      font-weight: normal;
    }
  }
}
.simple-table {
  margin-top: 10px;
}

</style>
